import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'md',
    iconfont: 'mdi',
  },

  theme: {
    themes: {
      light: {
        // primary: '#FFFFFF', //white
        primary: '#C7A754',
        secondary: '#004D8C', //techblue
        techgold: '#DDB95C',
        buzzgold: '#EAAA00',
      },
      dark: {
        primary: '#C7A754',
        secondary: '#004D8C', //techblue
        techgold: '#DDB95C',
        buzzgold: '#EAAA00',

      }
    }
  }
  

})
